import { useEffect } from 'react'

import { fetchPropertyNearby } from 'actions/OfferActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { EmptyObject } from 'lib/object/objectUtils'

const EMPTY: App.NearbyByCategory = {}

function usePropertyNearby(
  propertyId: string | undefined,
  options: { disabled?: boolean } = EmptyObject,
): App.NearbyByCategory {
  const dispatch = useAppDispatch()
  const entry = useAppSelector((state) => state.offer.propertyNearby[propertyId ?? ''])

  useEffect(() => {
    if (!options.disabled && propertyId) {
      dispatch(fetchPropertyNearby(propertyId))
    }
  }, [propertyId, options.disabled, dispatch])

  return options.disabled ? EMPTY : (entry?.nearby ?? EMPTY)
}

export default usePropertyNearby
